import { Divider, Stack, styled, Typography } from '@mui/material';
import { forwardRef } from 'react';

const NewMessagesDividerRoot = styled(Stack, {
  name: 'NewMessagesDividerRoot',
  shouldForwardProp: (prop) => prop !== 'isDismissing',
})<{ isDismissing: boolean }>(({ theme, isDismissing }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  opacity: isDismissing ? 0 : 1,
  transition: 'opacity 400ms ease',
}));

const NewMessagesDividerLine = styled(Divider, {
  name: 'NewMessagesDividerLine',
})(({ theme }) => ({
  flex: 1,
  borderColor: theme.palette.custom.OV.sys.primary,
}));

const NewMessagesDividerLabel = styled(Typography, {
  name: 'NewMessagesDividerLabel',
})(({ theme }) => ({
  flexShrink: 0,
  margin: theme.spacing(0, 1),
  fontSize: '0.75rem',
  fontWeight: 600,
  lineHeight: 1.6,
  color: theme.palette.custom.OV.sys.primary,
}));

export interface NewMessagesDividerProps {
  count: number;
  isDismissing?: boolean;
}

export const NewMessagesDivider = forwardRef<HTMLDivElement, NewMessagesDividerProps>(
  ({ count, isDismissing = false }, ref) => {
    const label = count === 1 ? '1 new message' : `${count} new messages`;

    return (
      <NewMessagesDividerRoot
        ref={ref}
        isDismissing={isDismissing}
        data-testid="new-messages-divider"
      >
        <NewMessagesDividerLine />
        <NewMessagesDividerLabel variant="caption">{label}</NewMessagesDividerLabel>
        <NewMessagesDividerLine />
      </NewMessagesDividerRoot>
    );
  },
);

NewMessagesDivider.displayName = 'NewMessagesDivider';
